var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Station"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52048 11.194H15.4787C15.3955 8.83493 14.951 6.74584 14.2988 5.224C13.9353 4.37603 13.5233 3.74131 13.1068 3.33029C12.6938 2.92269 12.3206 2.77431 11.9996 2.77431C11.6786 2.77431 11.3053 2.92269 10.8923 3.33029C10.4759 3.74131 10.0638 4.37603 9.70041 5.224C9.04819 6.74584 8.60372 8.83493 8.52048 11.194ZM15.4787 12.8062C15.3954 15.1653 14.951 17.2543 14.2988 18.7762C13.9353 19.6241 13.5233 20.2589 13.1068 20.6699C12.6938 21.0775 12.3206 21.2259 11.9996 21.2259C11.6786 21.2259 11.3053 21.0775 10.8923 20.6699C10.4759 20.2589 10.0638 19.6241 9.70041 18.7762C9.0482 17.2543 8.60372 15.1653 8.52049 12.8062H15.4787ZM17.0919 12.8062H21.9998C21.6505 17.1988 18.4718 20.7945 14.2865 21.7702C14.8781 21.17 15.3767 20.3538 15.7807 19.4113C16.5323 17.6576 17.0082 15.3444 17.0919 12.8062ZM21.9998 11.194H17.0919C17.0082 8.65582 16.5323 6.34263 15.7807 4.5889C15.3767 3.6464 14.8781 2.83016 14.2865 2.22998C18.4718 3.20574 21.6505 6.80137 21.9998 11.194ZM6.90729 11.194H1.99976C2.349 6.80153 5.52749 3.206 9.71252 2.23008C9.121 2.83026 8.6224 3.64646 8.2185 4.5889C7.4669 6.34263 6.99092 8.65582 6.90729 11.194ZM6.90729 12.8062H1.99976C2.34902 17.1987 5.5275 20.7942 9.71253 21.7701C9.12101 21.1699 8.6224 20.3537 8.2185 19.4113C7.4669 17.6576 6.99092 15.3444 6.90729 12.8062Z",
    fill: "#070A26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.09abb59031bcae4f8cd32836414363e6.svg";
export { ForwardRef as ReactComponent };